/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PrivacyWarningCurrentAliases {
  FETCH_PRIVACY_WARNING = 'fetch-privacy-warning',
  PANEL_PRIVACY_WARNING_MAIN = 'panel-privacy-warning-main',
  TERM_SERVICE_0 = 'term-service-0',
}
export { PrivacyWarningCurrentAliases };
